export default __webpack_public_path__ + "arrow.6d1542d0.svg";